// The columnists a user can follow. Ids and image URLs were verified against
// the live story-feed API (credits.by._id and credits.by.image.url) on
// 2026-07-19; images are served from Arc's author-service CDN.
//
// The user's stored follows are keyed by `name`, so renaming an entry here
// orphans any existing follow of it.
export const AUTHOR_CATALOGUE = [
  {
    name: 'Cliff Taylor',
    id: 'cliff-taylor',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/EMLNJPM6FFASJPEXSDADKBJL4Q.png',
  },
  {
    name: "Fintan O'Toole",
    id: 'fintan-otoole',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/7XQQ74P72NHOHIZSTW5OQZWRUQ.png',
  },
  {
    name: 'Finn McRedmond',
    id: 'finn-mcredmond',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/3AMLVGG7HBEMTLW4EDCSEXVF3Q.png',
  },
  {
    name: 'Hugh Linehan',
    id: 'hugh-linehan',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/OZZZH7QBPRGIZBRCBNXYYBEQRQ.png',
  },
  {
    // Note: no hyphen between O and Connell in the CMS id.
    name: "Jennifer O'Connell",
    id: 'jennifer-oconnell',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/EXCVUEDZ7VCAJJMFX6U2AT4G34.png',
  },
  {
    name: 'John McManus',
    id: 'john-mcmanus',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/PMCPJAK3GNB5BCKYCGMCBIW3ZM.png',
  },
  {
    name: 'Justine McCarthy',
    id: 'justine-mccarthy',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/JLVV7K7OMFG7VMBSOGX2GPDP2A.png',
  },
  {
    name: 'Kathy Sheridan',
    id: 'kathy-sheridan',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/UPAA6RJ53NHFFIGLPIRXGVKAXE.png',
  },
  {
    name: 'Miriam Lord',
    id: 'miriam-lord',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/SHP46O5I6JBJZKQCUTZH3LEBDE.png',
  },
  {
    name: 'Newton Emerson',
    id: 'newton-emerson',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/GU7LCKZEONEZTBYTJEFVK6QXQE.png',
  },
  {
    name: 'Pat Leahy',
    id: 'pat-leahy',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/GTMLW27ZNNC2XO32XZYGBDULY4.png',
  },
  {
    name: 'Róisín Ingle',
    id: 'roisin-ingle',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/P5CDMM4LZBA6LG7CWFJ2CP4ETM.png',
  },
  {
    name: 'Una Mullally',
    id: 'una-mullally',
    image:
      'https://author-service-images-prod-us-east-1.publishing.aws.arc.pub/irishtimes/E7MLCWX3PNH3NKBU7XWRDY5RNE.png',
  },
];

const byName = new Map(AUTHOR_CATALOGUE.map((author) => [author.name, author]));

// Every columnist a user can follow, in the order the picker lists them.
export const ALL_AUTHORS = AUTHOR_CATALOGUE.map((author) => author.name);

// Headshot for a columnist name, or '' when we have none (render an initial).
export function authorImage(name) {
  return byName.get(name)?.image || '';
}

// Builds the story-feed query for the followed columnists, e.g.
// (credits.by._id:"miriam-lord" OR ...). Returns null when nobody is
// followed, which the feed reads as "nothing to fetch".
export function buildAuthorsQuery(authors) {
  const clauses = authors
    .map((name) => byName.get(name)?.id)
    .filter(Boolean)
    .map((id) => `credits.by._id:"${id}"`);

  return clauses.length > 0 ? `(${clauses.join(' OR ')})` : null;
}
